/* eslint-disable import/no-cycle */
import React, { useCallback, useState } from 'react'

import { getHexadecimal } from '../../utils/helpers'
import LinkComponent from '../LinkComponent/LinkComponent'
import { Kicker } from '../Typography'
import {
  accordionBtn,
  accordionContent,
  accordionItem,
  accordionOpen,
  activeNumber,
  arrowActive,
  arrowDown,
  arrowRotated,
  indicatorNumber,
  separatorLine,
  titleContainer,
} from './AccordionItem.module.css'
import AccordionContent from './AcoodionContent'
import UspAccordion from './UspAccordion'

const AccordionItem = ({
  active,
  contentClassname,
  extraActiveTitleClassName,
  extraClassName,
  extraContentClassname,
  extraOpenClassname,
  extraTitleClassname,
  faqSection,
  index,
  innerBtnClassName,
  item = {},
  rotated,
  titleClassname,
  withIndicator,
  withKicker,
  withoutTitle,
  withTitle,
  withUnderline,
}) => {
  const [isOpen, setIsOpen] = useState(active)
  const { fieldGroupName, link, title } = item

  const onClick = useCallback(() => {
    if (!link) {
      setIsOpen((prevIsOpen) => !prevIsOpen)
    }
  }, [link])

  return (
    <li
      className={`${accordionItem} ${extraClassName} ${
        isOpen ? extraOpenClassname : ''
      }`}
    >
      <button
        className={`${accordionBtn} ${innerBtnClassName}`}
        onClick={() => onClick()}
        onKeyDown={() => onClick()}
        tabIndex="0"
        type="button"
      >
        <div className={`${titleContainer}`}>
          {withIndicator && (
            <div className={`${indicatorNumber} ${isOpen ? activeNumber : ''}`}>
              {getHexadecimal(index + 1)}
            </div>
          )}
          {title && !link && (
            <Kicker
              extraClassName={`${extraTitleClassname} ${
                isOpen ? `${titleClassname} ${extraActiveTitleClassName}` : ''
              }`}
              faqSection={faqSection}
            >
              {title}
            </Kicker>
          )}
          {title && link && (
            <LinkComponent className={`${titleClassname}`} src={link}>
              {title}
            </LinkComponent>
          )}
          {withUnderline && title && isOpen && (
            <div className={separatorLine} />
          )}
        </div>
        <div
          className={`${arrowDown} ${isOpen ? arrowActive : ''} ${
            rotated ? arrowRotated : ''
          }`}
        />
      </button>
      <div
        className={`${accordionContent} ${extraContentClassname} ${
          isOpen ? accordionOpen : ''
        } ${contentClassname}`}
      >
        {!fieldGroupName?.includes('usp') && (
          <AccordionContent
            {...item}
            withKicker={withKicker}
            withTitle={withTitle}
          />
        )}
        {fieldGroupName?.includes('usp') && (
          <UspAccordion withoutTitle={withoutTitle} {...item} />
        )}
      </div>
    </li>
  )
}

export default AccordionItem
